import * as amplitude from '@amplitude/analytics-browser'
import { autocapturePlugin } from '@amplitude/plugin-autocapture-browser'

// Export amplitude instance for use in composables
export { amplitude }

/**
 * Setup Amplitude Analytics with autocapture enabled
 */
export function setupAmplitude() {
  // Get API key from environment variables
  const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY

  if (!apiKey) {
    console.warn('Amplitude API key not found. Please set VITE_AMPLITUDE_API_KEY in your environment variables.')
    return
  }

  // Initialize Amplitude with autocapture enabled
  amplitude.init(apiKey, undefined, {
    autocapture: {
      elementInteractions: true,
    },
  })

  // Add autocapture plugin
  amplitude.add(autocapturePlugin())

  console.log('Amplitude Analytics initialized with autocapture enabled')
}
